import React, { ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

/**
 * Checklist above the fold, in the hero
 */
const LandingHighlights = ({items}: { items: ReactNode[] }) =>
  <ul className={'list-none! pl-0!'}>
    {items.map((item, index) => <li key={index} className={'flex! items-baseline gap-2'}>
      <FontAwesomeIcon icon={faCheck} className={'shrink-0'} /><span>{item}</span>
    </li>)}
  </ul>;

export default LandingHighlights;
